import React from 'react';
import styled from 'styled-components';
import NavLink from '../global/NavLink';
import H1 from '../global/typography/H1';
import InnerWrapper from '../global/InnerWrapper';

const Container = styled.div`
  background-color: ${p => p.theme.color.bgPrimary};
  padding: 88px 0;
`;

const InnerContainer = styled(InnerWrapper)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Heading = styled(H1)`
  margin-bottom: 43px;
`;

const LinksWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  gap: 10px;

  @media (min-width: ${p => p.theme.deviceWidth.tablet}) {
    justify-content: space-between;
  }
`;

const LinkWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  background-color: ${p => p.theme.color.tertiary};
  border: ${p => `1px solid ${p.theme.color.borderPrimaryDarkened}`};
  border-radius: 8px;
  font-family: ${p => p.theme.font.metaOt};
  font-size: 16px;
  font-weight: ${p => p.theme.fontWeight.black};
  line-height: 24px;
  margin-bottom: 16px;
  max-width: 274px;
  padding: 15px;
  text-align: center;
  text-transform: uppercase;
  transition: background-color 0.2s ease-in;

  &:hover {
    background-color: ${p => p.theme.color.bgPrimary};
  }
`;

const Image = styled.img`
  max-width: 110px;
`;

const Link = styled(NavLink)`
  display: block;
  text-align: left;
`;

const links = [
  {
    image: {
      alt: 'noble water heater',
      src: 'home/small-noble.png'
    },
    text: 'Noble® Combination Gas Boiler',
    url: '/noble'
  },
  {
    image: {
      alt: 'veritus air source commericial heat pump water heater',
      src: 'home/small-veritus.png'
    },
    text: 'Veritus™ Air Source Commercial Heat Pump Water Heater',
    url: '/veritus'
  },
  {
    image: {
      alt: 'lectrus commericial electric boiler',
      src: 'home/lectrus-small.png'
    },
    text: 'Lectrus™ Commericial Electric Boiler',
    url: '/lectrus'
  },
  {
    image: {
      alt: 'crest condensing boilder',
      src: 'home/small-crest.png'
    },
    function: () => (
      <span>
        The Crest<sup>&reg;</sup> Condensing Boiler
      </span>
    ),
    url: '/crest'
  }
];

const FeaturedProducts = () => (
  <Container>
    <InnerContainer>
      <Heading>Featured Products</Heading>
      <LinksWrapper>
        {links.map((link, idx) => (
          <LinkWrapper key={idx}>
            <Link exact={false} to={link.url}>
              {link.function ? link.function() : link.text}
            </Link>
            <Image src={link.image.src} alt={link.image.alt} />
          </LinkWrapper>
        ))}
      </LinksWrapper>
    </InnerContainer>
  </Container>
);

export default FeaturedProducts;
